//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  headerText: {
    textAlign: "left",
    font: "normal normal normal 1.5vw Segoe-ui",
    marginBottom: 0,
    letterSpacing: "0px",
    color: " #707070",
    fontSize: 28,
    display: "block",
    textAlign: "center",
  },
  topGrid: {
    display: "flex",
    alignItems: "center",
  },
  searchInput: {
    width: 400,
    borderRadius: 20,
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  badge: {
    backgroundColor: "#C52025",
    color: "#fff",
    fontWeight: "bold",
    position: "absolute",
    right: -10,
    top: -15,
  },
  filterBtn: {
    marginLeft: 20,
  },
  root: {
    flexGrow: 1,
    marginBottom: 20,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  filterCardDiv: {
    "@media (max-width: 600px)": {
      overflow: "scroll",
    },
  },
  filterCard: {
    boxShadow: " 10px 10px 10px #00000029 !important",
    border: " 1px solid #707070",
    borderRadius: "20px !important",
    width: 600,
    zIndex: 100,
    marginBottom: 20,
  },
  filterCardGridContainer: {
    height: "100%",
  },
  filterCardGrid: {
    borderRight: "1px solid #0000004D",
    alignSelf: "center",
  },
  filterCardHeadText: {
    fontWeight: "bold",
    fontSize: 24,
  },
  filterCardSubHeadText: {
    fontSize: 24,
  },
  filterCardInput: {
    borderRadius: 10,
  },
  filterCardBtnGrid: {
    textAlign: "center",
    alignSelf: "center",
  },
  filterCardResetBtn: {
    color: "#305698",
    backgroundColor: "#fff",
    fontSize: "0.875rem",
    border: " 1px solid #305698",
    borderRadius: 10,
    width: 100,
    height: 35,
    textTransform: "capitalize",
    marginTop: "5%",
  },
  filterCardApplyBtn: {
    color: "#fff",
    backgroundColor: "#305698 !important",
    fontSize: "0.875rem",
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 100,
    height: 35,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#305698 !important",
    },
  },
  tableDiv: {
    marginTop: 20,
  },
  emptyDataText: {
    textAlign: "center",
    fontSize: 30,
    fontFamily: "segoe-ui",
    padding: "10%",
    opacity: "0.4",
  },
  tableDownInResponsive: {
    marginBottom: 150,
  },
  cursorPointer: {
    cursor: "pointer",
  },
  displayNone: {
    display: "none",
  },
  cronJobBtnGrid: {
    alignItems: "center",
    textAlign: "right",
    alignSelf: "center",
  },
  cronJobBtn: {
    color: "#fff",
    backgroundColor: "#305698",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 160,
    height: 35,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#305698",
    },
  },
  searchInputIcon: {
    cursor: "pointer",
  },
  // Dialog
  dialogParentDiv: {
    padding: 25,
  },
  parentText: {
    fontSize: 25,
  },
}));
